export const SELECTION_UPDATED = 'selection_updated';
export const SELECTION_CLEARED = 'selection_cleared';
export const SELECTION_ITEM_ADDED = 'selection_item_added';
export const SELECTION_ITEM_REMOVED = 'selection_item_removed';
